//import { CONTACTS_DEFAULT_END, CONTACTS_DEFAULT_START } from '../conf/mtma-contacts';

export class Plant {
    Capabilities: string;
    Description: string;
    DeviceId: number;
    Id: number;
    IpAddress: string;
    Keycode: string;
    Name: string;
    OwnerEmail: string;
    OwnerId: number;
    ParentId: number;
    PlantType: string;
    ProductId: number;
    SiteId: number;
    UpdatedAt: string;
    Modules: ModuleVct[];

    constructor() {
    }
}

export class UVVct {
    Id: number;
    Name: string;
    AliasName: string;
    ModuleId: number;
    OwnerId: number;
    OwnerEmail: string;
    UpdatedAt?: string;
    Features: FeatureVct[];
    Settings: SettingVct[];
    WarningError?: boolean;
    WarningErrorType?: string;

    constructor() {}
}

export class ModuleVct {
    AliasName: string;
    Id: number;
    ModuleId: number;
    Name: string;
    OwnerEmail: string;
    Features: FeatureVct[];
    SettingVct: SettingVct[];
    SipAccounts: SipAccountVct[];
    WarningError?: boolean;
    WarningErrorType?: string;

    constructor() {
    }
}

export class FeatureVct {
    AliasName: string;
    Id: number;
    FeatureId: number;
    Name: string;
    OwnerEmail: string;
    Settings: SettingVct[];
    SipAccount: SipAccountVct;
    ModuleAccess: boolean;
    WarningError?: boolean;
    WarningErrorType?: string;

    constructor() {
    }
}


export class SettingVct {
    SettingId: number;
    UpdatedAt: Date;
    Value: string;

    constructor() {
    }
}

export class SipAccountVct {
    BptL3Addr: string;
    SipUsername: string;
    UpdatedAt: Date;
    UserEmail: string;
    UserId: number;

    constructor() {
    }
}

export interface DevicesVctTree {
    Id: number;
    Name: string;
    Description: string;
    IconName: string;
    ModelId: number;
    Children: TreeNodeVct[];
    Expand?: boolean;
}

export interface TreeNodeVct {
    id: number;
    expandable: boolean;
    name: string;
    level: number;
    icon?: string;
}



export class VctExportRow {
    Id: string;
    Name: string;
    Type: string;
    OwnerEmail: string;
}